module.exports = "/lucky-balls/img/bonus_yellow/header_soccer.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_soccer.png
// module id = 970
// module chunks = 0